import {    
    IMarketingCompensatedDiscountsDTO,    
    IMarketingCompensatedDiscountsProductsDTO,    
    IMarketingCompensatedDiscountsProductsViewDTO,    
    IMarketingCompensatedDiscountsViewDTO
} from "../../libs/coreapi-dto/dirs/marketingCompensatedDiscounts";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class MarketingCompensatedDiscountsDataProvider extends DictionaryDataProvider<IMarketingCompensatedDiscountsViewDTO, IMarketingCompensatedDiscountsDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IMarketingCompensatedDiscountsViewDTO, IMarketingCompensatedDiscountsDTO>> {
        return this._coreApiService.marketingCompensatedDiscountsRequest
    }

    getViewParam(filter: IViewBody, callback?: (data: IMarketingCompensatedDiscountsViewDTO[], totalCount: number,) => void, report?: (value) => void) {
        this._coreApiService.marketingCompensatedDiscountsRequest
            .then(r => r
                .getViewParam(filter, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.detail ?? 'DictionaryDataProvider getView !isCompleted');
                }, (value) => { report?.(value) })
            )
            .catch((e) => {
                throw new Error(e?.message.text ?? 'getView DictionaryDataProvider')
            });
    }
}

//Товары Компенсируемых скидок
export class MarketingCompensatedDiscountsProductsDataProvider extends DictionaryDataProvider<IMarketingCompensatedDiscountsProductsViewDTO, IMarketingCompensatedDiscountsProductsDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IMarketingCompensatedDiscountsProductsViewDTO, IMarketingCompensatedDiscountsProductsDTO>> {
        return this._coreApiService.marketingCompensatedDiscountsProductsRequest
    }

    getViewParam(filter: IViewBody, callback?: (data: IMarketingCompensatedDiscountsProductsViewDTO[], totalCount: number,) => void, report?: (value) => void) {
        this._coreApiService.marketingCompensatedDiscountsProductsRequest
            .then(r => r
                .getViewParam(filter, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.detail ?? 'DictionaryDataProvider getView !isCompleted');
                }, (value) => { report?.(value) })
            )
            .catch((e) => {
                throw new Error(e?.message.text ?? 'getView DictionaryDataProvider')
            });
    }
}